import { Key, Natural, Positive, URI, unwrapNatural, unwrapPositive, validNatural, validPositive } from './std';


import { AdvancedColorMode, ColorPalette, Font, Theme, validAdvancedColorMode, validColorPalette, validFont, validTheme } from './theme';


declare const EmailBrand: unique symbol;
export type Email = string & { readonly [EmailBrand]: typeof EmailBrand };
export function wrapEmail(value: string): Email { return value as Email; }
export function unwrapEmail(value: Email): string { return value; }

export const validEmail = (x: string): Email => {
  return x as Email;
}

declare const SlugBrand: unique symbol;
export type Slug = string & { readonly [SlugBrand]: typeof SlugBrand };
export function wrapSlug(value: string): Slug { return value as Slug; }
export function unwrapSlug(value: Slug): string { return value; }

export const validSlug = (x: string): Slug => {
  return x as Slug;
}

declare const PasswordHashBrand: unique symbol;
export type PasswordHash = string & { readonly [PasswordHashBrand]: typeof PasswordHashBrand };
export function wrapPasswordHash(value: string): PasswordHash { return value as PasswordHash; }
export function unwrapPasswordHash(value: PasswordHash): string { return value; }

export const validPasswordHash = (x: string): PasswordHash => {
  return x as PasswordHash;
}

declare const BranchNameBrand: unique symbol;
export type BranchName = string & { readonly [BranchNameBrand]: typeof BranchNameBrand };
export function wrapBranchName(value: string): BranchName { return value as BranchName; }
export function unwrapBranchName(value: BranchName): string { return value; }

export const validBranchName = (x: string): BranchName => {
  return x as BranchName;
}

declare const LaneSlugBrand: unique symbol;
export type LaneSlug = string & { readonly [LaneSlugBrand]: typeof LaneSlugBrand };
export function wrapLaneSlug(value: string): LaneSlug { return value as LaneSlug; }
export function unwrapLaneSlug(value: LaneSlug): string { return value; }

export const validLaneSlug = (x: string): LaneSlug => {
  return x as LaneSlug;
}

declare const AvatarUrlBrand: unique symbol;
export type AvatarUrl = string & { readonly [AvatarUrlBrand]: typeof AvatarUrlBrand };
export function wrapAvatarUrl(value: string): AvatarUrl { return value as AvatarUrl; }
export function unwrapAvatarUrl(value: AvatarUrl): string { return value; }

export const validAvatarUrl = (x: string): AvatarUrl => {
  return x as AvatarUrl;
}

declare const BioBrand: unique symbol;
export type Bio = string & { readonly [BioBrand]: typeof BioBrand };
export function wrapBio(value: string): Bio { return value as Bio; }
export function unwrapBio(value: Bio): string { return value; }

export const validBio = (x: string): Bio => {
  return x as Bio;
}

declare const HeadlineBrand: unique symbol;
export type Headline = string & { readonly [HeadlineBrand]: typeof HeadlineBrand };
export function wrapHeadline(value: string): Headline { return value as Headline; }
export function unwrapHeadline(value: Headline): string { return value; }

export const validHeadline = (x: string): Headline => {
  return x as Headline;
}

declare const StatusTextBrand: unique symbol;
export type StatusText = string & { readonly [StatusTextBrand]: typeof StatusTextBrand };
export function wrapStatusText(value: string): StatusText { return value as StatusText; }
export function unwrapStatusText(value: StatusText): string { return value; }

export const validStatusText = (x: string): StatusText => {
  return x as StatusText;
}

declare const LocationBrand: unique symbol;
export type Location = string & { readonly [LocationBrand]: typeof LocationBrand };
export function wrapLocation(value: string): Location { return value as Location; }
export function unwrapLocation(value: Location): string { return value; }

export const validLocation = (x: string): Location => {
  return x as Location;
}

declare const TimezoneBrand: unique symbol;
export type Timezone = string & { readonly [TimezoneBrand]: typeof TimezoneBrand };
export function wrapTimezone(value: string): Timezone { return value as Timezone; }
export function unwrapTimezone(value: Timezone): string { return value; }

export const validTimezone = (x: string): Timezone => {
  return x as Timezone;
}

declare const PronounsBrand: unique symbol;
export type Pronouns = string & { readonly [PronounsBrand]: typeof PronounsBrand };
export function wrapPronouns(value: string): Pronouns { return value as Pronouns; }
export function unwrapPronouns(value: Pronouns): string { return value; }

export const validPronouns = (x: string): Pronouns => {
  return x as Pronouns;
}

declare const UrlBrand: unique symbol;
export type Url = string & { readonly [UrlBrand]: typeof UrlBrand };
export function wrapUrl(value: string): Url { return value as Url; }
export function unwrapUrl(value: Url): string { return value; }

export const validUrl = (x: string): Url => {
  return x as Url;
}

declare const OidcSubjectBrand: unique symbol;
export type OidcSubject = string & { readonly [OidcSubjectBrand]: typeof OidcSubjectBrand };
export function wrapOidcSubject(value: string): OidcSubject { return value as OidcSubject; }
export function unwrapOidcSubject(value: OidcSubject): string { return value; }

export const validOidcSubject = (x: string): OidcSubject => {
  return x as OidcSubject;
}

declare const OidcIssuerBrand: unique symbol;
export type OidcIssuer = string & { readonly [OidcIssuerBrand]: typeof OidcIssuerBrand };
export function wrapOidcIssuer(value: string): OidcIssuer { return value as OidcIssuer; }
export function unwrapOidcIssuer(value: OidcIssuer): string { return value; }

export const validOidcIssuer = (x: string): OidcIssuer => {
  return x as OidcIssuer;
}

declare const FocusBrand: unique symbol;
export type Focus = string & { readonly [FocusBrand]: typeof FocusBrand };
export function wrapFocus(value: string): Focus { return value as Focus; }
export function unwrapFocus(value: Focus): string { return value; }

export const validFocus = (x: string): Focus => {
  return x as Focus;
}

declare const ContextLineBrand: unique symbol;
export type ContextLine = string & { readonly [ContextLineBrand]: typeof ContextLineBrand };
export function wrapContextLine(value: string): ContextLine { return value as ContextLine; }
export function unwrapContextLine(value: ContextLine): string { return value; }

export const validContextLine = (x: string): ContextLine => {
  return x as ContextLine;
}

declare const MetricValueBrand: unique symbol;
export type MetricValue = string & { readonly [MetricValueBrand]: typeof MetricValueBrand };
export function wrapMetricValue(value: string): MetricValue { return value as MetricValue; }
export function unwrapMetricValue(value: MetricValue): string { return value; }

export const validMetricValue = (x: string): MetricValue => {
  return x as MetricValue;
}

declare const MetricLabelBrand: unique symbol;
export type MetricLabel = string & { readonly [MetricLabelBrand]: typeof MetricLabelBrand };
export function wrapMetricLabel(value: string): MetricLabel { return value as MetricLabel; }
export function unwrapMetricLabel(value: MetricLabel): string { return value; }

export const validMetricLabel = (x: string): MetricLabel => {
  return x as MetricLabel;
}

declare const AnnotationLabelBrand: unique symbol;
export type AnnotationLabel = string & { readonly [AnnotationLabelBrand]: typeof AnnotationLabelBrand };
export function wrapAnnotationLabel(value: string): AnnotationLabel { return value as AnnotationLabel; }
export function unwrapAnnotationLabel(value: AnnotationLabel): string { return value; }

export const validAnnotationLabel = (x: string): AnnotationLabel => {
  return x as AnnotationLabel;
}

declare const TagNameBrand: unique symbol;
export type TagName = string & { readonly [TagNameBrand]: typeof TagNameBrand };
export function wrapTagName(value: string): TagName { return value as TagName; }
export function unwrapTagName(value: TagName): string { return value; }

export const validTagName = (x: string): TagName => {
  return x as TagName;
}

declare const DerivationPathBrand: unique symbol;
export type DerivationPath = string & { readonly [DerivationPathBrand]: typeof DerivationPathBrand };
export function wrapDerivationPath(value: string): DerivationPath { return value as DerivationPath; }
export function unwrapDerivationPath(value: DerivationPath): string { return value; }

export const validDerivationPath = (x: string): DerivationPath => {
  return x as DerivationPath;
}

declare const StorePathBrand: unique symbol;
export type StorePath = string & { readonly [StorePathBrand]: typeof StorePathBrand };
export function wrapStorePath(value: string): StorePath { return value as StorePath; }
export function unwrapStorePath(value: StorePath): string { return value; }

export const validStorePath = (x: string): StorePath => {
  return x as StorePath;
}

declare const AttrPathBrand: unique symbol;
export type AttrPath = string & { readonly [AttrPathBrand]: typeof AttrPathBrand };
export function wrapAttrPath(value: string): AttrPath { return value as AttrPath; }
export function unwrapAttrPath(value: AttrPath): string { return value; }

export const validAttrPath = (x: string): AttrPath => {
  return x as AttrPath;
}

declare const DrvHashBrand: unique symbol;
export type DrvHash = string & { readonly [DrvHashBrand]: typeof DrvHashBrand };
export function wrapDrvHash(value: string): DrvHash { return value as DrvHash; }
export function unwrapDrvHash(value: DrvHash): string { return value; }

export const validDrvHash = (x: string): DrvHash => {
  return x as DrvHash;
}

declare const FlakeLockHashBrand: unique symbol;
export type FlakeLockHash = string & { readonly [FlakeLockHashBrand]: typeof FlakeLockHashBrand };
export function wrapFlakeLockHash(value: string): FlakeLockHash { return value as FlakeLockHash; }
export function unwrapFlakeLockHash(value: FlakeLockHash): string { return value; }

export const validFlakeLockHash = (x: string): FlakeLockHash => {
  return x as FlakeLockHash;
}

declare const NarHashBrand: unique symbol;
export type NarHash = string & { readonly [NarHashBrand]: typeof NarHashBrand };
export function wrapNarHash(value: string): NarHash { return value as NarHash; }
export function unwrapNarHash(value: NarHash): string { return value; }

export const validNarHash = (x: string): NarHash => {
  return x as NarHash;
}

declare const DisplayNameBrand: unique symbol;
export type DisplayName = string & { readonly [DisplayNameBrand]: typeof DisplayNameBrand };
export function wrapDisplayName(value: string): DisplayName { return value as DisplayName; }
export function unwrapDisplayName(value: DisplayName): string { return value; }

export const validDisplayName = (x: string): DisplayName => {
  return x as DisplayName;
}

declare const GroupNameBrand: unique symbol;
export type GroupName = string & { readonly [GroupNameBrand]: typeof GroupNameBrand };
export function wrapGroupName(value: string): GroupName { return value as GroupName; }
export function unwrapGroupName(value: GroupName): string { return value; }

export const validGroupName = (x: string): GroupName => {
  return x as GroupName;
}

declare const GroupPathBrand: unique symbol;
export type GroupPath = string & { readonly [GroupPathBrand]: typeof GroupPathBrand };
export function wrapGroupPath(value: string): GroupPath { return value as GroupPath; }
export function unwrapGroupPath(value: GroupPath): string { return value; }

export const validGroupPath = (x: string): GroupPath => {
  return x as GroupPath;
}

declare const RepoNameBrand: unique symbol;
export type RepoName = string & { readonly [RepoNameBrand]: typeof RepoNameBrand };
export function wrapRepoName(value: string): RepoName { return value as RepoName; }
export function unwrapRepoName(value: RepoName): string { return value; }

export const validRepoName = (x: string): RepoName => {
  return x as RepoName;
}

declare const KeyNameBrand: unique symbol;
export type KeyName = string & { readonly [KeyNameBrand]: typeof KeyNameBrand };
export function wrapKeyName(value: string): KeyName { return value as KeyName; }
export function unwrapKeyName(value: KeyName): string { return value; }

export const validKeyName = (x: string): KeyName => {
  return x as KeyName;
}

declare const StatusEmojiBrand: unique symbol;
export type StatusEmoji = string & { readonly [StatusEmojiBrand]: typeof StatusEmojiBrand };
export function wrapStatusEmoji(value: string): StatusEmoji { return value as StatusEmoji; }
export function unwrapStatusEmoji(value: StatusEmoji): string { return value; }

export const validStatusEmoji = (x: string): StatusEmoji => {
  return x as StatusEmoji;
}

declare const ShortDescriptionBrand: unique symbol;
export type ShortDescription = string & { readonly [ShortDescriptionBrand]: typeof ShortDescriptionBrand };
export function wrapShortDescription(value: string): ShortDescription { return value as ShortDescription; }
export function unwrapShortDescription(value: ShortDescription): string { return value; }

export const validShortDescription = (x: string): ShortDescription => {
  return x as ShortDescription;
}

declare const TitleBrand: unique symbol;
export type Title = string & { readonly [TitleBrand]: typeof TitleBrand };
export function wrapTitle(value: string): Title { return value as Title; }
export function unwrapTitle(value: Title): string { return value; }

export const validTitle = (x: string): Title => {
  return x as Title;
}

declare const BodyBrand: unique symbol;
export type Body = string & { readonly [BodyBrand]: typeof BodyBrand };
export function wrapBody(value: string): Body { return value as Body; }
export function unwrapBody(value: Body): string { return value; }

export const validBody = (x: string): Body => {
  return x as Body;
}

declare const StoryRoleBrand: unique symbol;
export type StoryRole = string & { readonly [StoryRoleBrand]: typeof StoryRoleBrand };
export function wrapStoryRole(value: string): StoryRole { return value as StoryRole; }
export function unwrapStoryRole(value: StoryRole): string { return value; }

export const validStoryRole = (x: string): StoryRole => {
  return x as StoryRole;
}

declare const AuthRoleBrand: unique symbol;
export type AuthRole = string & { readonly [AuthRoleBrand]: typeof AuthRoleBrand };
export function wrapAuthRole(value: string): AuthRole { return value as AuthRole; }
export function unwrapAuthRole(value: AuthRole): string { return value; }

export const validAuthRole = (x: string): AuthRole => {
  return x as AuthRole;
}

declare const PublicKeyBrand: unique symbol;
export type PublicKey = string & { readonly [PublicKeyBrand]: typeof PublicKeyBrand };
export function wrapPublicKey(value: string): PublicKey { return value as PublicKey; }
export function unwrapPublicKey(value: PublicKey): string { return value; }

export const validPublicKey = (x: string): PublicKey => {
  return x as PublicKey;
}

declare const FingerprintBrand: unique symbol;
export type Fingerprint = string & { readonly [FingerprintBrand]: typeof FingerprintBrand };
export function wrapFingerprint(value: string): Fingerprint { return value as Fingerprint; }
export function unwrapFingerprint(value: Fingerprint): string { return value; }

export const validFingerprint = (x: string): Fingerprint => {
  return x as Fingerprint;
}

declare const KeyTypeBrand: unique symbol;
export type KeyType = string & { readonly [KeyTypeBrand]: typeof KeyTypeBrand };
export function wrapKeyType(value: string): KeyType { return value as KeyType; }
export function unwrapKeyType(value: KeyType): string { return value; }

export const validKeyType = (x: string): KeyType => {
  return x as KeyType;
}

declare const ExpiresAtBrand: unique symbol;
export type ExpiresAt = string & { readonly [ExpiresAtBrand]: typeof ExpiresAtBrand };
export function wrapExpiresAt(value: string): ExpiresAt { return value as ExpiresAt; }
export function unwrapExpiresAt(value: ExpiresAt): string { return value; }

export const validExpiresAt = (x: string): ExpiresAt => {
  return x as ExpiresAt;
}

declare const LastUsedAtBrand: unique symbol;
export type LastUsedAt = string & { readonly [LastUsedAtBrand]: typeof LastUsedAtBrand };
export function wrapLastUsedAt(value: string): LastUsedAt { return value as LastUsedAt; }
export function unwrapLastUsedAt(value: LastUsedAt): string { return value; }

export const validLastUsedAt = (x: string): LastUsedAt => {
  return x as LastUsedAt;
}

declare const LastLoginAtBrand: unique symbol;
export type LastLoginAt = Natural & { readonly [LastLoginAtBrand]: typeof LastLoginAtBrand };
export function wrapLastLoginAt(value: Natural): LastLoginAt { return value as LastLoginAt; }
export function unwrapLastLoginAt(value: LastLoginAt): Natural { return value; }

export const validLastLoginAt = (x: Natural): LastLoginAt => {
  return x as LastLoginAt;
}

declare const BigNaturalBrand: unique symbol;
export type BigNatural = number & { readonly [BigNaturalBrand]: typeof BigNaturalBrand };
export function wrapBigNatural(value: number): BigNatural { return value as BigNatural; }
export function unwrapBigNatural(value: BigNatural): number { return value; }

declare const ProbabilityBrand: unique symbol;
export type Probability = number & { readonly [ProbabilityBrand]: typeof ProbabilityBrand };
export function wrapProbability(value: number): Probability { return value as Probability; }
export function unwrapProbability(value: Probability): number { return value; }

declare const LoadAverageBrand: unique symbol;
export type LoadAverage = number & { readonly [LoadAverageBrand]: typeof LoadAverageBrand };
export function wrapLoadAverage(value: number): LoadAverage { return value as LoadAverage; }
export function unwrapLoadAverage(value: LoadAverage): number { return value; }

declare const CommitShaBrand: unique symbol;
export type CommitSha = string & { readonly [CommitShaBrand]: typeof CommitShaBrand };
export function wrapCommitSha(value: string): CommitSha { return value as CommitSha; }
export function unwrapCommitSha(value: CommitSha): string { return value; }

export const validCommitSha = (x: string): CommitSha => {
  return x as CommitSha;
}

declare const GitRevBrand: unique symbol;
export type GitRev = string & { readonly [GitRevBrand]: typeof GitRevBrand };
export function wrapGitRev(value: string): GitRev { return value as GitRev; }
export function unwrapGitRev(value: GitRev): string { return value; }

export const validGitRev = (x: string): GitRev => {
  return x as GitRev;
}

declare const FlakeOutputBrand: unique symbol;
export type FlakeOutput = string & { readonly [FlakeOutputBrand]: typeof FlakeOutputBrand };
export function wrapFlakeOutput(value: string): FlakeOutput { return value as FlakeOutput; }
export function unwrapFlakeOutput(value: FlakeOutput): string { return value; }

export const validFlakeOutput = (x: string): FlakeOutput => {
  return x as FlakeOutput;
}

declare const FlakeInputNameBrand: unique symbol;
export type FlakeInputName = string & { readonly [FlakeInputNameBrand]: typeof FlakeInputNameBrand };
export function wrapFlakeInputName(value: string): FlakeInputName { return value as FlakeInputName; }
export function unwrapFlakeInputName(value: FlakeInputName): string { return value; }

export const validFlakeInputName = (x: string): FlakeInputName => {
  return x as FlakeInputName;
}

declare const BuildLogBrand: unique symbol;
export type BuildLog = string & { readonly [BuildLogBrand]: typeof BuildLogBrand };
export function wrapBuildLog(value: string): BuildLog { return value as BuildLog; }
export function unwrapBuildLog(value: BuildLog): string { return value; }

export const validBuildLog = (x: string): BuildLog => {
  return x as BuildLog;
}

declare const ErrorOutputBrand: unique symbol;
export type ErrorOutput = string & { readonly [ErrorOutputBrand]: typeof ErrorOutputBrand };
export function wrapErrorOutput(value: string): ErrorOutput { return value as ErrorOutput; }
export function unwrapErrorOutput(value: ErrorOutput): string { return value; }

export const validErrorOutput = (x: string): ErrorOutput => {
  return x as ErrorOutput;
}

declare const OutputTreeBrand: unique symbol;
export type OutputTree = string & { readonly [OutputTreeBrand]: typeof OutputTreeBrand };
export function wrapOutputTree(value: string): OutputTree { return value as OutputTree; }
export function unwrapOutputTree(value: OutputTree): string { return value; }

export const validOutputTree = (x: string): OutputTree => {
  return x as OutputTree;
}

declare const EventPayloadBrand: unique symbol;
export type EventPayload = string & { readonly [EventPayloadBrand]: typeof EventPayloadBrand };
export function wrapEventPayload(value: string): EventPayload { return value as EventPayload; }
export function unwrapEventPayload(value: EventPayload): string { return value; }

export const validEventPayload = (x: string): EventPayload => {
  return x as EventPayload;
}

declare const FilePathBrand: unique symbol;
export type FilePath = string & { readonly [FilePathBrand]: typeof FilePathBrand };
export function wrapFilePath(value: string): FilePath { return value as FilePath; }
export function unwrapFilePath(value: FilePath): string { return value; }

export const validFilePath = (x: string): FilePath => {
  return x as FilePath;
}

declare const Base64BodyBrand: unique symbol;
export type Base64Body = string & { readonly [Base64BodyBrand]: typeof Base64BodyBrand };
export function wrapBase64Body(value: string): Base64Body { return value as Base64Body; }
export function unwrapBase64Body(value: Base64Body): string { return value; }

export const validBase64Body = (x: string): Base64Body => {
  return x as Base64Body;
}

declare const BranchPatternBrand: unique symbol;
export type BranchPattern = string & { readonly [BranchPatternBrand]: typeof BranchPatternBrand };
export function wrapBranchPattern(value: string): BranchPattern { return value as BranchPattern; }
export function unwrapBranchPattern(value: BranchPattern): string { return value; }

export const validBranchPattern = (x: string): BranchPattern => {
  return x as BranchPattern;
}

declare const TagPatternBrand: unique symbol;
export type TagPattern = string & { readonly [TagPatternBrand]: typeof TagPatternBrand };
export function wrapTagPattern(value: string): TagPattern { return value as TagPattern; }
export function unwrapTagPattern(value: TagPattern): string { return value; }

export const validTagPattern = (x: string): TagPattern => {
  return x as TagPattern;
}

declare const ContributionDateBrand: unique symbol;
export type ContributionDate = string & { readonly [ContributionDateBrand]: typeof ContributionDateBrand };
export function wrapContributionDate(value: string): ContributionDate { return value as ContributionDate; }
export function unwrapContributionDate(value: ContributionDate): string { return value; }

export const validContributionDate = (x: string): ContributionDate => {
  return x as ContributionDate;
}

declare const StartDateBrand: unique symbol;
export type StartDate = string & { readonly [StartDateBrand]: typeof StartDateBrand };
export function wrapStartDate(value: string): StartDate { return value as StartDate; }
export function unwrapStartDate(value: StartDate): string { return value; }

export const validStartDate = (x: string): StartDate => {
  return x as StartDate;
}

declare const EndDateBrand: unique symbol;
export type EndDate = string & { readonly [EndDateBrand]: typeof EndDateBrand };
export function wrapEndDate(value: string): EndDate { return value as EndDate; }
export function unwrapEndDate(value: EndDate): string { return value; }

export const validEndDate = (x: string): EndDate => {
  return x as EndDate;
}

declare const FailedLoginAttemptsBrand: unique symbol;
export type FailedLoginAttempts = Natural & { readonly [FailedLoginAttemptsBrand]: typeof FailedLoginAttemptsBrand };
export function wrapFailedLoginAttempts(value: Natural): FailedLoginAttempts { return value as FailedLoginAttempts; }
export function unwrapFailedLoginAttempts(value: FailedLoginAttempts): Natural { return value; }

export const validFailedLoginAttempts = (x: Natural): FailedLoginAttempts => {
  return x as FailedLoginAttempts;
}

declare const LockedUntilBrand: unique symbol;
export type LockedUntil = Natural & { readonly [LockedUntilBrand]: typeof LockedUntilBrand };
export function wrapLockedUntil(value: Natural): LockedUntil { return value as LockedUntil; }
export function unwrapLockedUntil(value: LockedUntil): Natural { return value; }

export const validLockedUntil = (x: Natural): LockedUntil => {
  return x as LockedUntil;
}

declare const DeletionScheduledAtBrand: unique symbol;
export type DeletionScheduledAt = Natural & { readonly [DeletionScheduledAtBrand]: typeof DeletionScheduledAtBrand };
export function wrapDeletionScheduledAt(value: Natural): DeletionScheduledAt { return value as DeletionScheduledAt; }
export function unwrapDeletionScheduledAt(value: DeletionScheduledAt): Natural { return value; }

export const validDeletionScheduledAt = (x: Natural): DeletionScheduledAt => {
  return x as DeletionScheduledAt;
}

declare const CommitCountBrand: unique symbol;
export type CommitCount = Natural & { readonly [CommitCountBrand]: typeof CommitCountBrand };
export function wrapCommitCount(value: Natural): CommitCount { return value as CommitCount; }
export function unwrapCommitCount(value: CommitCount): Natural { return value; }

export const validCommitCount = (x: Natural): CommitCount => {
  return x as CommitCount;
}

declare const PrCountBrand: unique symbol;
export type PrCount = Natural & { readonly [PrCountBrand]: typeof PrCountBrand };
export function wrapPrCount(value: Natural): PrCount { return value as PrCount; }
export function unwrapPrCount(value: PrCount): Natural { return value; }

export const validPrCount = (x: Natural): PrCount => {
  return x as PrCount;
}

declare const ReviewCountBrand: unique symbol;
export type ReviewCount = Natural & { readonly [ReviewCountBrand]: typeof ReviewCountBrand };
export function wrapReviewCount(value: Natural): ReviewCount { return value as ReviewCount; }
export function unwrapReviewCount(value: ReviewCount): Natural { return value; }

export const validReviewCount = (x: Natural): ReviewCount => {
  return x as ReviewCount;
}

declare const JobCountBrand: unique symbol;
export type JobCount = Natural & { readonly [JobCountBrand]: typeof JobCountBrand };
export function wrapJobCount(value: Natural): JobCount { return value as JobCount; }
export function unwrapJobCount(value: JobCount): Natural { return value; }

export const validJobCount = (x: Natural): JobCount => {
  return x as JobCount;
}

declare const RetryCountBrand: unique symbol;
export type RetryCount = Natural & { readonly [RetryCountBrand]: typeof RetryCountBrand };
export function wrapRetryCount(value: Natural): RetryCount { return value as RetryCount; }
export function unwrapRetryCount(value: RetryCount): Natural { return value; }

export const validRetryCount = (x: Natural): RetryCount => {
  return x as RetryCount;
}

declare const DurationMsBrand: unique symbol;
export type DurationMs = Natural & { readonly [DurationMsBrand]: typeof DurationMsBrand };
export function wrapDurationMs(value: Natural): DurationMs { return value as DurationMs; }
export function unwrapDurationMs(value: DurationMs): Natural { return value; }

export const validDurationMs = (x: Natural): DurationMs => {
  return x as DurationMs;
}

declare const ClosureSizeBrand: unique symbol;
export type ClosureSize = Natural & { readonly [ClosureSizeBrand]: typeof ClosureSizeBrand };
export function wrapClosureSize(value: Natural): ClosureSize { return value as ClosureSize; }
export function unwrapClosureSize(value: ClosureSize): Natural { return value; }

export const validClosureSize = (x: Natural): ClosureSize => {
  return x as ClosureSize;
}

declare const RequiredApprovalsBrand: unique symbol;
export type RequiredApprovals = Natural & { readonly [RequiredApprovalsBrand]: typeof RequiredApprovalsBrand };
export function wrapRequiredApprovals(value: Natural): RequiredApprovals { return value as RequiredApprovals; }
export function unwrapRequiredApprovals(value: RequiredApprovals): Natural { return value; }

export const validRequiredApprovals = (x: Natural): RequiredApprovals => {
  return x as RequiredApprovals;
}

declare const KeyBitsBrand: unique symbol;
export type KeyBits = Positive & { readonly [KeyBitsBrand]: typeof KeyBitsBrand };
export function wrapKeyBits(value: Positive): KeyBits { return value as KeyBits; }
export function unwrapKeyBits(value: KeyBits): Positive { return value; }

declare const PositionBrand: unique symbol;
export type Position = Positive & { readonly [PositionBrand]: typeof PositionBrand };
export function wrapPosition(value: Positive): Position { return value as Position; }
export function unwrapPosition(value: Position): Positive { return value; }

export const validPosition = (x: Positive): Position => {
  return x as Position;
}

declare const RetryMaxAttemptsBrand: unique symbol;
export type RetryMaxAttempts = Positive & { readonly [RetryMaxAttemptsBrand]: typeof RetryMaxAttemptsBrand };
export function wrapRetryMaxAttempts(value: Positive): RetryMaxAttempts { return value as RetryMaxAttempts; }
export function unwrapRetryMaxAttempts(value: RetryMaxAttempts): Positive { return value; }

export const validRetryMaxAttempts = (x: Positive): RetryMaxAttempts => {
  return x as RetryMaxAttempts;
}

declare const RetryBaseDelayMsBrand: unique symbol;
export type RetryBaseDelayMs = Positive & { readonly [RetryBaseDelayMsBrand]: typeof RetryBaseDelayMsBrand };
export function wrapRetryBaseDelayMs(value: Positive): RetryBaseDelayMs { return value as RetryBaseDelayMs; }
export function unwrapRetryBaseDelayMs(value: RetryBaseDelayMs): Positive { return value; }

export const validRetryBaseDelayMs = (x: Positive): RetryBaseDelayMs => {
  return x as RetryBaseDelayMs;
}

declare const AttemptNumberBrand: unique symbol;
export type AttemptNumber = Positive & { readonly [AttemptNumberBrand]: typeof AttemptNumberBrand };
export function wrapAttemptNumber(value: Positive): AttemptNumber { return value as AttemptNumber; }
export function unwrapAttemptNumber(value: AttemptNumber): Positive { return value; }

export const validAttemptNumber = (x: Positive): AttemptNumber => {
  return x as AttemptNumber;
}

declare const LineNumberBrand: unique symbol;
export type LineNumber = Positive & { readonly [LineNumberBrand]: typeof LineNumberBrand };
export function wrapLineNumber(value: Positive): LineNumber { return value as LineNumber; }
export function unwrapLineNumber(value: LineNumber): Positive { return value; }

export const validLineNumber = (x: Positive): LineNumber => {
  return x as LineNumber;
}

declare const ExitCodeBrand: unique symbol;
export type ExitCode = number & { readonly [ExitCodeBrand]: typeof ExitCodeBrand };
export function wrapExitCode(value: number): ExitCode { return value as ExitCode; }
export function unwrapExitCode(value: ExitCode): number { return value; }

declare const RunnerTokenBrand: unique symbol;
export type RunnerToken = string & { readonly [RunnerTokenBrand]: typeof RunnerTokenBrand };
export function wrapRunnerToken(value: string): RunnerToken { return value as RunnerToken; }
export function unwrapRunnerToken(value: RunnerToken): string { return value; }

export const validRunnerToken = (x: string): RunnerToken => {
  return x as RunnerToken;
}

declare const RunnerNameBrand: unique symbol;
export type RunnerName = string & { readonly [RunnerNameBrand]: typeof RunnerNameBrand };
export function wrapRunnerName(value: string): RunnerName { return value as RunnerName; }
export function unwrapRunnerName(value: RunnerName): string { return value; }

export const validRunnerName = (x: string): RunnerName => {
  return x as RunnerName;
}

declare const Ed25519PubkeyBrand: unique symbol;
export type Ed25519Pubkey = string & { readonly [Ed25519PubkeyBrand]: typeof Ed25519PubkeyBrand };
export function wrapEd25519Pubkey(value: string): Ed25519Pubkey { return value as Ed25519Pubkey; }
export function unwrapEd25519Pubkey(value: Ed25519Pubkey): string { return value; }

export const validEd25519Pubkey = (x: string): Ed25519Pubkey => {
  return x as Ed25519Pubkey;
}

declare const JobIdWireBrand: unique symbol;
export type JobIdWire = string & { readonly [JobIdWireBrand]: typeof JobIdWireBrand };
export function wrapJobIdWire(value: string): JobIdWire { return value as JobIdWire; }
export function unwrapJobIdWire(value: JobIdWire): string { return value; }

export const validJobIdWire = (x: string): JobIdWire => {
  return x as JobIdWire;
}

declare const EvalIdWireBrand: unique symbol;
export type EvalIdWire = string & { readonly [EvalIdWireBrand]: typeof EvalIdWireBrand };
export function wrapEvalIdWire(value: string): EvalIdWire { return value as EvalIdWire; }
export function unwrapEvalIdWire(value: EvalIdWire): string { return value; }

export const validEvalIdWire = (x: string): EvalIdWire => {
  return x as EvalIdWire;
}

declare const Base64NonceBrand: unique symbol;
export type Base64Nonce = string & { readonly [Base64NonceBrand]: typeof Base64NonceBrand };
export function wrapBase64Nonce(value: string): Base64Nonce { return value as Base64Nonce; }
export function unwrapBase64Nonce(value: Base64Nonce): string { return value; }

export const validBase64Nonce = (x: string): Base64Nonce => {
  return x as Base64Nonce;
}

declare const Base64SignatureBrand: unique symbol;
export type Base64Signature = string & { readonly [Base64SignatureBrand]: typeof Base64SignatureBrand };
export function wrapBase64Signature(value: string): Base64Signature { return value as Base64Signature; }
export function unwrapBase64Signature(value: Base64Signature): string { return value; }

export const validBase64Signature = (x: string): Base64Signature => {
  return x as Base64Signature;
}

declare const GroupTokenSecretBrand: unique symbol;
export type GroupTokenSecret = string & { readonly [GroupTokenSecretBrand]: typeof GroupTokenSecretBrand };
export function wrapGroupTokenSecret(value: string): GroupTokenSecret { return value as GroupTokenSecret; }
export function unwrapGroupTokenSecret(value: GroupTokenSecret): string { return value; }

export const validGroupTokenSecret = (x: string): GroupTokenSecret => {
  return x as GroupTokenSecret;
}

declare const TsUnixMsBrand: unique symbol;
export type TsUnixMs = number & { readonly [TsUnixMsBrand]: typeof TsUnixMsBrand };
export function wrapTsUnixMs(value: number): TsUnixMs { return value as TsUnixMs; }
export function unwrapTsUnixMs(value: TsUnixMs): number { return value; }

export const validTsUnixMs = (x: number): TsUnixMs => {
  return x as TsUnixMs;
}

declare const RejectionReasonBrand: unique symbol;
export type RejectionReason = string & { readonly [RejectionReasonBrand]: typeof RejectionReasonBrand };
export function wrapRejectionReason(value: string): RejectionReason { return value as RejectionReason; }
export function unwrapRejectionReason(value: RejectionReason): string { return value; }

export const validRejectionReason = (x: string): RejectionReason => {
  return x as RejectionReason;
}

declare const CpuModelBrand: unique symbol;
export type CpuModel = string & { readonly [CpuModelBrand]: typeof CpuModelBrand };
export function wrapCpuModel(value: string): CpuModel { return value as CpuModel; }
export function unwrapCpuModel(value: CpuModel): string { return value; }

export const validCpuModel = (x: string): CpuModel => {
  return x as CpuModel;
}

declare const NixFeaturesBrand: unique symbol;
export type NixFeatures = string & { readonly [NixFeaturesBrand]: typeof NixFeaturesBrand };
export function wrapNixFeatures(value: string): NixFeatures { return value as NixFeatures; }
export function unwrapNixFeatures(value: NixFeatures): string { return value; }

export const validNixFeatures = (x: string): NixFeatures => {
  return x as NixFeatures;
}

declare const SubstitutersBrand: unique symbol;
export type Substituters = string & { readonly [SubstitutersBrand]: typeof SubstitutersBrand };
export function wrapSubstituters(value: string): Substituters { return value as Substituters; }
export function unwrapSubstituters(value: Substituters): string { return value; }

export const validSubstituters = (x: string): Substituters => {
  return x as Substituters;
}

declare const CoresBrand: unique symbol;
export type Cores = Natural & { readonly [CoresBrand]: typeof CoresBrand };
export function wrapCores(value: Natural): Cores { return value as Cores; }
export function unwrapCores(value: Cores): Natural { return value; }

export const validCores = (x: Natural): Cores => {
  return x as Cores;
}

declare const RamBytesBrand: unique symbol;
export type RamBytes = BigNatural & { readonly [RamBytesBrand]: typeof RamBytesBrand };
export function wrapRamBytes(value: BigNatural): RamBytes { return value as RamBytes; }
export function unwrapRamBytes(value: RamBytes): BigNatural { return value; }

declare const LastConnectedAtBrand: unique symbol;
export type LastConnectedAt = Natural & { readonly [LastConnectedAtBrand]: typeof LastConnectedAtBrand };
export function wrapLastConnectedAt(value: Natural): LastConnectedAt { return value as LastConnectedAt; }
export function unwrapLastConnectedAt(value: LastConnectedAt): Natural { return value; }

export const validLastConnectedAt = (x: Natural): LastConnectedAt => {
  return x as LastConnectedAt;
}

declare const StartedAtBrand: unique symbol;
export type StartedAt = BigNatural & { readonly [StartedAtBrand]: typeof StartedAtBrand };
export function wrapStartedAt(value: BigNatural): StartedAt { return value as StartedAt; }
export function unwrapStartedAt(value: StartedAt): BigNatural { return value; }

export const validStartedAt = (x: BigNatural): StartedAt => {
  return x as StartedAt;
}

declare const EndedAtBrand: unique symbol;
export type EndedAt = BigNatural & { readonly [EndedAtBrand]: typeof EndedAtBrand };
export function wrapEndedAt(value: BigNatural): EndedAt { return value as EndedAt; }
export function unwrapEndedAt(value: EndedAt): BigNatural { return value; }

export const validEndedAt = (x: BigNatural): EndedAt => {
  return x as EndedAt;
}

declare const BanditProbabilityBrand: unique symbol;
export type BanditProbability = Probability & { readonly [BanditProbabilityBrand]: typeof BanditProbabilityBrand };
export function wrapBanditProbability(value: Probability): BanditProbability { return value as BanditProbability; }
export function unwrapBanditProbability(value: BanditProbability): Probability { return value; }

export const validBanditProbability = (x: Probability): BanditProbability => {
  return x as BanditProbability;
}

declare const BanditCostBrand: unique symbol;
export type BanditCost = number & { readonly [BanditCostBrand]: typeof BanditCostBrand };
export function wrapBanditCost(value: number): BanditCost { return value as BanditCost; }
export function unwrapBanditCost(value: BanditCost): number { return value; }

export const validBanditCost = (x: number): BanditCost => {
  return x as BanditCost;
}

declare const ChosenIdxBrand: unique symbol;
export type ChosenIdx = Natural & { readonly [ChosenIdxBrand]: typeof ChosenIdxBrand };
export function wrapChosenIdx(value: Natural): ChosenIdx { return value as ChosenIdx; }
export function unwrapChosenIdx(value: ChosenIdx): Natural { return value; }

export const validChosenIdx = (x: Natural): ChosenIdx => {
  return x as ChosenIdx;
}

declare const SharedFeaturesJsonBrand: unique symbol;
export type SharedFeaturesJson = string & { readonly [SharedFeaturesJsonBrand]: typeof SharedFeaturesJsonBrand };
export function wrapSharedFeaturesJson(value: string): SharedFeaturesJson { return value as SharedFeaturesJson; }
export function unwrapSharedFeaturesJson(value: SharedFeaturesJson): string { return value; }

export const validSharedFeaturesJson = (x: string): SharedFeaturesJson => {
  return x as SharedFeaturesJson;
}

declare const ActionFeaturesJsonBrand: unique symbol;
export type ActionFeaturesJson = string & { readonly [ActionFeaturesJsonBrand]: typeof ActionFeaturesJsonBrand };
export function wrapActionFeaturesJson(value: string): ActionFeaturesJson { return value as ActionFeaturesJson; }
export function unwrapActionFeaturesJson(value: ActionFeaturesJson): string { return value; }

export const validActionFeaturesJson = (x: string): ActionFeaturesJson => {
  return x as ActionFeaturesJson;
}

declare const DispatchedAtBrand: unique symbol;
export type DispatchedAt = BigNatural & { readonly [DispatchedAtBrand]: typeof DispatchedAtBrand };
export function wrapDispatchedAt(value: BigNatural): DispatchedAt { return value as DispatchedAt; }
export function unwrapDispatchedAt(value: DispatchedAt): BigNatural { return value; }

export const validDispatchedAt = (x: BigNatural): DispatchedAt => {
  return x as DispatchedAt;
}

declare const OutcomeAtBrand: unique symbol;
export type OutcomeAt = BigNatural & { readonly [OutcomeAtBrand]: typeof OutcomeAtBrand };
export function wrapOutcomeAt(value: BigNatural): OutcomeAt { return value as OutcomeAt; }
export function unwrapOutcomeAt(value: OutcomeAt): BigNatural { return value; }

export const validOutcomeAt = (x: BigNatural): OutcomeAt => {
  return x as OutcomeAt;
}

declare const ReplayedAtBrand: unique symbol;
export type ReplayedAt = BigNatural & { readonly [ReplayedAtBrand]: typeof ReplayedAtBrand };
export function wrapReplayedAt(value: BigNatural): ReplayedAt { return value as ReplayedAt; }
export function unwrapReplayedAt(value: ReplayedAt): BigNatural { return value; }

export const validReplayedAt = (x: BigNatural): ReplayedAt => {
  return x as ReplayedAt;
}

declare const ProtocolVersionBrand: unique symbol;
export type ProtocolVersion = Positive & { readonly [ProtocolVersionBrand]: typeof ProtocolVersionBrand };
export function wrapProtocolVersion(value: Positive): ProtocolVersion { return value as ProtocolVersion; }
export function unwrapProtocolVersion(value: ProtocolVersion): Positive { return value; }

declare const EnvHostNameBrand: unique symbol;
export type EnvHostName = string & { readonly [EnvHostNameBrand]: typeof EnvHostNameBrand };
export function wrapEnvHostName(value: string): EnvHostName { return value as EnvHostName; }
export function unwrapEnvHostName(value: EnvHostName): string { return value; }

export const validEnvHostName = (x: string): EnvHostName => {
  return x as EnvHostName;
}

declare const SessionSamplesJsonBrand: unique symbol;
export type SessionSamplesJson = string & { readonly [SessionSamplesJsonBrand]: typeof SessionSamplesJsonBrand };
export function wrapSessionSamplesJson(value: string): SessionSamplesJson { return value as SessionSamplesJson; }
export function unwrapSessionSamplesJson(value: SessionSamplesJson): string { return value; }

export const validSessionSamplesJson = (x: string): SessionSamplesJson => {
  return x as SessionSamplesJson;
}

declare const EnvSessionIdWireBrand: unique symbol;
export type EnvSessionIdWire = string & { readonly [EnvSessionIdWireBrand]: typeof EnvSessionIdWireBrand };
export function wrapEnvSessionIdWire(value: string): EnvSessionIdWire { return value as EnvSessionIdWire; }
export function unwrapEnvSessionIdWire(value: EnvSessionIdWire): string { return value; }

export const validEnvSessionIdWire = (x: string): EnvSessionIdWire => {
  return x as EnvSessionIdWire;
}

declare const SecretNameBrand: unique symbol;
export type SecretName = string & { readonly [SecretNameBrand]: typeof SecretNameBrand };
export function wrapSecretName(value: string): SecretName { return value as SecretName; }
export function unwrapSecretName(value: SecretName): string { return value; }

export const validSecretName = (x: string): SecretName => {
  return x as SecretName;
}

declare const SealedEnvelopeBrand: unique symbol;
export type SealedEnvelope = string & { readonly [SealedEnvelopeBrand]: typeof SealedEnvelopeBrand };
export function wrapSealedEnvelope(value: string): SealedEnvelope { return value as SealedEnvelope; }
export function unwrapSealedEnvelope(value: SealedEnvelope): string { return value; }

export const validSealedEnvelope = (x: string): SealedEnvelope => {
  return x as SealedEnvelope;
}

declare const ScopeUnitNameBrand: unique symbol;
export type ScopeUnitName = string & { readonly [ScopeUnitNameBrand]: typeof ScopeUnitNameBrand };
export function wrapScopeUnitName(value: string): ScopeUnitName { return value as ScopeUnitName; }
export function unwrapScopeUnitName(value: ScopeUnitName): string { return value; }

export const validScopeUnitName = (x: string): ScopeUnitName => {
  return x as ScopeUnitName;
}

export type AccessLevel = "none" | "read" | "write" | "admin"

export const validAccessLevel = (x: unknown): AccessLevel => {
  const v = x as [string, unknown] | string;
  if(((v != 'none')) && ((v != 'read')) && ((v != 'write')) && ((v != 'admin'))) throw new Error('Invalid AccessLevel `' + JSON.stringify(x) + '`');
  return x as AccessLevel;
}

export type Visibility = "public" | "internal" | "private"

export const validVisibility = (x: unknown): Visibility => {
  const v = x as [string, unknown] | string;
  if(((v != 'public')) && ((v != 'internal')) && ((v != 'private'))) throw new Error('Invalid Visibility `' + JSON.stringify(x) + '`');
  return x as Visibility;
}

export type KeyUsage = "authentication" | "signing" | "authAndSigning"

export const validKeyUsage = (x: unknown): KeyUsage => {
  const v = x as [string, unknown] | string;
  if(((v != 'authentication')) && ((v != 'signing')) && ((v != 'authAndSigning'))) throw new Error('Invalid KeyUsage `' + JSON.stringify(x) + '`');
  return x as KeyUsage;
}

export type SquashSetting = "defaultSquash" | "doNotAllow" | "allowSquash" | "encourage" | "requireSquash"

export const validSquashSetting = (x: unknown): SquashSetting => {
  const v = x as [string, unknown] | string;
  if(((v != 'defaultSquash')) && ((v != 'doNotAllow')) && ((v != 'allowSquash')) && ((v != 'encourage')) && ((v != 'requireSquash'))) throw new Error('Invalid SquashSetting `' + JSON.stringify(x) + '`');
  return x as SquashSetting;
}

export type PermissionLevel = "noOne" | "developers" | "maintainers" | "developersAndMaintainers"

export const validPermissionLevel = (x: unknown): PermissionLevel => {
  const v = x as [string, unknown] | string;
  if(((v != 'noOne')) && ((v != 'developers')) && ((v != 'maintainers')) && ((v != 'developersAndMaintainers'))) throw new Error('Invalid PermissionLevel `' + JSON.stringify(x) + '`');
  return x as PermissionLevel;
}

export type DevSessionPhase = "initializing" | "ready" | "rebuilding" | "draining" | "terminated"

export const validDevSessionPhase = (x: unknown): DevSessionPhase => {
  const v = x as [string, unknown] | string;
  if(((v != 'initializing')) && ((v != 'ready')) && ((v != 'rebuilding')) && ((v != 'draining')) && ((v != 'terminated'))) throw new Error('Invalid DevSessionPhase `' + JSON.stringify(x) + '`');
  return x as DevSessionPhase;
}

export type DevSessionEvent = "sessionReady" | "flakeChanged" | "rebuildDone" | "rebuildFailed" | "drain" | "reconnect" | "drainTimeout" | "terminate"

export const validDevSessionEvent = (x: unknown): DevSessionEvent => {
  const v = x as [string, unknown] | string;
  if(((v != 'sessionReady')) && ((v != 'flakeChanged')) && ((v != 'rebuildDone')) && ((v != 'rebuildFailed')) && ((v != 'drain')) && ((v != 'reconnect')) && ((v != 'drainTimeout')) && ((v != 'terminate'))) throw new Error('Invalid DevSessionEvent `' + JSON.stringify(x) + '`');
  return x as DevSessionEvent;
}

export type AdminEventKind = "revokeHost" | "rotateGroupToken" | "pinDispatch" | "changePolicy" | "revokeSession" | "forceTerminate"

export const validAdminEventKind = (x: unknown): AdminEventKind => {
  const v = x as [string, unknown] | string;
  if(((v != 'revokeHost')) && ((v != 'rotateGroupToken')) && ((v != 'pinDispatch')) && ((v != 'changePolicy')) && ((v != 'revokeSession')) && ((v != 'forceTerminate'))) throw new Error('Invalid AdminEventKind `' + JSON.stringify(x) + '`');
  return x as AdminEventKind;
}

export interface User {
  email: Email;
  username: Slug;
  passwordHash: PasswordHash;
  displayName: DisplayName;
  avatarUrl: AvatarUrl | null;
  failedLoginAttempts: FailedLoginAttempts;
  lockedUntil: LockedUntil | null;
  bio: Bio | null;
  headline: Headline | null;
  statusEmoji: StatusEmoji | null;
  statusText: StatusText | null;
  location: Location | null;
  timezone: Timezone | null;
  pronouns: Pronouns | null;
  focus: Focus | null;
  contextLine: ContextLine | null;
  availableForCollab: boolean;
  showActivityPublic: boolean;
  theme: Theme | null;
  font: Font | null;
  customColors: ColorPalette | null;
  advancedColorMode: AdvancedColorMode | null;
}

export const validUser = (input: unknown): User => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["email"] === undefined) throw new Error('`_x["email"]` required but not present');
  
  if (_x["username"] === undefined) throw new Error('`_x["username"]` required but not present');
  
  if (_x["passwordHash"] === undefined) throw new Error('`_x["passwordHash"]` required but not present');
  
  if (_x["displayName"] === undefined) throw new Error('`_x["displayName"]` required but not present');
  
  if (_x["avatarUrl"] === undefined) throw new Error('`_x["avatarUrl"]` required but not present');
  
  if (_x["failedLoginAttempts"] === undefined) throw new Error('`_x["failedLoginAttempts"]` required but not present');
  validNatural(unwrapNatural(unwrapFailedLoginAttempts(_x["failedLoginAttempts"] as any)) as any);
  if (_x["lockedUntil"] === undefined) throw new Error('`_x["lockedUntil"]` required but not present');
  _x["lockedUntil"] === null || validNatural(unwrapNatural(unwrapLockedUntil(_x["lockedUntil"] as any)) as any);
  if (_x["bio"] === undefined) throw new Error('`_x["bio"]` required but not present');
  
  if (_x["headline"] === undefined) throw new Error('`_x["headline"]` required but not present');
  
  if (_x["statusEmoji"] === undefined) throw new Error('`_x["statusEmoji"]` required but not present');
  
  if (_x["statusText"] === undefined) throw new Error('`_x["statusText"]` required but not present');
  
  if (_x["location"] === undefined) throw new Error('`_x["location"]` required but not present');
  
  if (_x["timezone"] === undefined) throw new Error('`_x["timezone"]` required but not present');
  
  if (_x["pronouns"] === undefined) throw new Error('`_x["pronouns"]` required but not present');
  
  if (_x["focus"] === undefined) throw new Error('`_x["focus"]` required but not present');
  
  if (_x["contextLine"] === undefined) throw new Error('`_x["contextLine"]` required but not present');
  
  // handle html checkbox bs
  if(_x["availableForCollab"] === undefined){
    _x["availableForCollab"] = false;
  }else if((_x["availableForCollab"] as unknown) === 'on'){
    _x["availableForCollab"] = true;
  }
  if (_x["availableForCollab"] === undefined) throw new Error('`_x["availableForCollab"]` required but not present');
  if (typeof _x["availableForCollab"] != 'boolean') throw new Error('`_x["availableForCollab"]` must be a boolean');
  // handle html checkbox bs
  if(_x["showActivityPublic"] === undefined){
    _x["showActivityPublic"] = false;
  }else if((_x["showActivityPublic"] as unknown) === 'on'){
    _x["showActivityPublic"] = true;
  }
  if (_x["showActivityPublic"] === undefined) throw new Error('`_x["showActivityPublic"]` required but not present');
  if (typeof _x["showActivityPublic"] != 'boolean') throw new Error('`_x["showActivityPublic"]` must be a boolean');
  if (_x["theme"] === undefined) throw new Error('`_x["theme"]` required but not present');
  _x["theme"] === null || validTheme(_x["theme"] as any);
  if (_x["font"] === undefined) throw new Error('`_x["font"]` required but not present');
  _x["font"] === null || validFont(_x["font"] as any);
  if (_x["customColors"] === undefined) throw new Error('`_x["customColors"]` required but not present');
  _x["customColors"] === null || validColorPalette(_x["customColors"] as any);
  if (_x["advancedColorMode"] === undefined) throw new Error('`_x["advancedColorMode"]` required but not present');
  _x["advancedColorMode"] === null || validAdvancedColorMode(_x["advancedColorMode"] as any);
  const x = input as User;
  return x;
}
export const isValidUser = (input: unknown): boolean => {
  try { validUser(input); return true; } catch { return false; }
}

export interface OidcIdentity {
  user: Key<User>;
  issuer: OidcIssuer;
  subject: OidcSubject;
  email: Email | null;
  displayName: DisplayName | null;
  avatarUrl: AvatarUrl | null;
  lastLoginAt: LastLoginAt | null;
}

export const validOidcIdentity = (input: unknown): OidcIdentity => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["user"] === undefined) throw new Error('`_x["user"]` required but not present');
  
  if (_x["issuer"] === undefined) throw new Error('`_x["issuer"]` required but not present');
  
  if (_x["subject"] === undefined) throw new Error('`_x["subject"]` required but not present');
  
  if (_x["email"] === undefined) throw new Error('`_x["email"]` required but not present');
  
  if (_x["displayName"] === undefined) throw new Error('`_x["displayName"]` required but not present');
  
  if (_x["avatarUrl"] === undefined) throw new Error('`_x["avatarUrl"]` required but not present');
  
  if (_x["lastLoginAt"] === undefined) throw new Error('`_x["lastLoginAt"]` required but not present');
  _x["lastLoginAt"] === null || validNatural(unwrapNatural(unwrapLastLoginAt(_x["lastLoginAt"] as any)) as any);
  const x = input as OidcIdentity;
  return x;
}
export const isValidOidcIdentity = (input: unknown): boolean => {
  try { validOidcIdentity(input); return true; } catch { return false; }
}

export interface Group {
  name: GroupName;
  slug: Slug;
  path: GroupPath;
  parentPath: GroupPath | null;
  isLeaf: boolean;
  visibility: Visibility;
  description: ShortDescription | null;
  avatarUrl: AvatarUrl | null;
  runnerToken: RunnerToken | null;
}

export const validGroup = (input: unknown): Group => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["name"] === undefined) throw new Error('`_x["name"]` required but not present');
  
  if (_x["slug"] === undefined) throw new Error('`_x["slug"]` required but not present');
  
  if (_x["path"] === undefined) throw new Error('`_x["path"]` required but not present');
  
  if (_x["parentPath"] === undefined) throw new Error('`_x["parentPath"]` required but not present');
  
  // handle html checkbox bs
  if(_x["isLeaf"] === undefined){
    _x["isLeaf"] = false;
  }else if((_x["isLeaf"] as unknown) === 'on'){
    _x["isLeaf"] = true;
  }
  if (_x["isLeaf"] === undefined) throw new Error('`_x["isLeaf"]` required but not present');
  if (typeof _x["isLeaf"] != 'boolean') throw new Error('`_x["isLeaf"]` must be a boolean');
  if (_x["visibility"] === undefined) throw new Error('`_x["visibility"]` required but not present');
  validVisibility(_x["visibility"] as any);
  if (_x["description"] === undefined) throw new Error('`_x["description"]` required but not present');
  
  if (_x["avatarUrl"] === undefined) throw new Error('`_x["avatarUrl"]` required but not present');
  
  if (_x["runnerToken"] === undefined) throw new Error('`_x["runnerToken"]` required but not present');
  
  const x = input as Group;
  return x;
}
export const isValidGroup = (input: unknown): boolean => {
  try { validGroup(input); return true; } catch { return false; }
}

export interface SshKey {
  user: Key<User>;
  name: KeyName;
  publicKey: PublicKey;
  fingerprint: Fingerprint;
  keyType: KeyType;
  keyBits: KeyBits | null;
  usageType: KeyUsage;
  expiresAt: ExpiresAt | null;
  lastUsedAt: LastUsedAt | null;
  isRevoked: boolean;
}

export const validSshKey = (input: unknown): SshKey => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["user"] === undefined) throw new Error('`_x["user"]` required but not present');
  
  if (_x["name"] === undefined) throw new Error('`_x["name"]` required but not present');
  
  if (_x["publicKey"] === undefined) throw new Error('`_x["publicKey"]` required but not present');
  
  if (_x["fingerprint"] === undefined) throw new Error('`_x["fingerprint"]` required but not present');
  
  if (_x["keyType"] === undefined) throw new Error('`_x["keyType"]` required but not present');
  
  if (_x["keyBits"] === undefined) throw new Error('`_x["keyBits"]` required but not present');
  _x["keyBits"] === null || validKeyBits(_x["keyBits"] as any);
  if (_x["usageType"] === undefined) throw new Error('`_x["usageType"]` required but not present');
  validKeyUsage(_x["usageType"] as any);
  if (_x["expiresAt"] === undefined) throw new Error('`_x["expiresAt"]` required but not present');
  
  if (_x["lastUsedAt"] === undefined) throw new Error('`_x["lastUsedAt"]` required but not present');
  
  // handle html checkbox bs
  if(_x["isRevoked"] === undefined){
    _x["isRevoked"] = false;
  }else if((_x["isRevoked"] as unknown) === 'on'){
    _x["isRevoked"] = true;
  }
  if (_x["isRevoked"] === undefined) throw new Error('`_x["isRevoked"]` required but not present');
  if (typeof _x["isRevoked"] != 'boolean') throw new Error('`_x["isRevoked"]` must be a boolean');
  const x = input as SshKey;
  return x;
}
export const isValidSshKey = (input: unknown): boolean => {
  try { validSshKey(input); return true; } catch { return false; }
}

export interface GroupMembership {
  user: Key<User>;
  groupPath: GroupPath;
  accessLevel: AccessLevel;
  accepted: boolean;
}

export const validGroupMembership = (input: unknown): GroupMembership => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["user"] === undefined) throw new Error('`_x["user"]` required but not present');
  
  if (_x["groupPath"] === undefined) throw new Error('`_x["groupPath"]` required but not present');
  
  if (_x["accessLevel"] === undefined) throw new Error('`_x["accessLevel"]` required but not present');
  validAccessLevel(_x["accessLevel"] as any);
  // handle html checkbox bs
  if(_x["accepted"] === undefined){
    _x["accepted"] = false;
  }else if((_x["accepted"] as unknown) === 'on'){
    _x["accepted"] = true;
  }
  if (_x["accepted"] === undefined) throw new Error('`_x["accepted"]` required but not present');
  if (typeof _x["accepted"] != 'boolean') throw new Error('`_x["accepted"]` must be a boolean');
  const x = input as GroupMembership;
  return x;
}
export const isValidGroupMembership = (input: unknown): boolean => {
  try { validGroupMembership(input); return true; } catch { return false; }
}

export type GroupMembershipStatus = "invited" | "accepted" | "closed"

export const validGroupMembershipStatus = (x: unknown): GroupMembershipStatus => {
  const v = x as [string, unknown] | string;
  if(((v != 'invited')) && ((v != 'accepted')) && ((v != 'closed'))) throw new Error('Invalid GroupMembershipStatus `' + JSON.stringify(x) + '`');
  return x as GroupMembershipStatus;
}

export type GroupMembershipEvent = "acceptInvitation" | "declineInvitation" | "revokeInvitation"

export const validGroupMembershipEvent = (x: unknown): GroupMembershipEvent => {
  const v = x as [string, unknown] | string;
  if(((v != 'acceptInvitation')) && ((v != 'declineInvitation')) && ((v != 'revokeInvitation'))) throw new Error('Invalid GroupMembershipEvent `' + JSON.stringify(x) + '`');
  return x as GroupMembershipEvent;
}

export interface GroupMembershipMachineContext {
  placeholder: number;
  zero: number;
}

export const validGroupMembershipMachineContext = (input: unknown): GroupMembershipMachineContext => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["placeholder"] === undefined) throw new Error('`_x["placeholder"]` required but not present');
  if (typeof _x["placeholder"] !== 'number' || !Number.isSafeInteger(_x["placeholder"] as number)) throw new Error('`_x["placeholder"]` must be a safe integer');
  if (_x["zero"] === undefined) throw new Error('`_x["zero"]` required but not present');
  if (typeof _x["zero"] !== 'number' || !Number.isSafeInteger(_x["zero"] as number)) throw new Error('`_x["zero"]` must be a safe integer');
  const x = input as GroupMembershipMachineContext;
  return x;
}
export const isValidGroupMembershipMachineContext = (input: unknown): boolean => {
  try { validGroupMembershipMachineContext(input); return true; } catch { return false; }
}

export interface AdminEvent {
  actor: Key<User>;
  kind: AdminEventKind;
  subjectType: string;
  subjectId: BigNatural;
  reason: string | null;
  metadata: string | null;
  occurredAt: StartedAt;
}

export const validAdminEvent = (input: unknown): AdminEvent => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["actor"] === undefined) throw new Error('`_x["actor"]` required but not present');
  
  if (_x["kind"] === undefined) throw new Error('`_x["kind"]` required but not present');
  validAdminEventKind(_x["kind"] as any);
  if (_x["subjectType"] === undefined) throw new Error('`_x["subjectType"]` required but not present');
  if (typeof _x["subjectType"] != 'string') throw new Error('`_x["subjectType"]` must be a string');
  if (_x["subjectId"] === undefined) throw new Error('`_x["subjectId"]` required but not present');
  validBigNatural(_x["subjectId"] as any);
  if (_x["reason"] === undefined) throw new Error('`_x["reason"]` required but not present');
  if (typeof _x["reason"] != 'string' && _x["reason"] != null) throw new Error('`_x["reason"]` must be a string | null');
  if (_x["metadata"] === undefined) throw new Error('`_x["metadata"]` required but not present');
  if (typeof _x["metadata"] != 'string' && _x["metadata"] != null) throw new Error('`_x["metadata"]` must be a string | null');
  if (_x["occurredAt"] === undefined) throw new Error('`_x["occurredAt"]` required but not present');
  validBigNatural(unwrapBigNatural(unwrapStartedAt(_x["occurredAt"] as any)) as any);
  const x = input as AdminEvent;
  return x;
}
export const isValidAdminEvent = (input: unknown): boolean => {
  try { validAdminEvent(input); return true; } catch { return false; }
}

export interface HistoryCommitFrame {
  hash: string;
  shortHash: string;
  author: string;
  timestamp: number;
  subject: string;
  path: string | null;
  blobSha: string | null;
  content: string | null;
}

export const validHistoryCommitFrame = (input: unknown): HistoryCommitFrame => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["hash"] === undefined) throw new Error('`_x["hash"]` required but not present');
  if (typeof _x["hash"] != 'string') throw new Error('`_x["hash"]` must be a string');
  if (_x["shortHash"] === undefined) throw new Error('`_x["shortHash"]` required but not present');
  if (typeof _x["shortHash"] != 'string') throw new Error('`_x["shortHash"]` must be a string');
  if (_x["author"] === undefined) throw new Error('`_x["author"]` required but not present');
  if (typeof _x["author"] != 'string') throw new Error('`_x["author"]` must be a string');
  if (_x["timestamp"] === undefined) throw new Error('`_x["timestamp"]` required but not present');
  if (typeof _x["timestamp"] !== 'number' || !Number.isSafeInteger(_x["timestamp"] as number)) throw new Error('`_x["timestamp"]` must be a safe integer');
  if (_x["subject"] === undefined) throw new Error('`_x["subject"]` required but not present');
  if (typeof _x["subject"] != 'string') throw new Error('`_x["subject"]` must be a string');
  if (_x["path"] === undefined) throw new Error('`_x["path"]` required but not present');
  if (typeof _x["path"] != 'string' && _x["path"] != null) throw new Error('`_x["path"]` must be a string | null');
  if (_x["blobSha"] === undefined) throw new Error('`_x["blobSha"]` required but not present');
  if (typeof _x["blobSha"] != 'string' && _x["blobSha"] != null) throw new Error('`_x["blobSha"]` must be a string | null');
  if (_x["content"] === undefined) throw new Error('`_x["content"]` required but not present');
  if (typeof _x["content"] != 'string' && _x["content"] != null) throw new Error('`_x["content"]` must be a string | null');
  const x = input as HistoryCommitFrame;
  return x;
}
export const isValidHistoryCommitFrame = (input: unknown): boolean => {
  try { validHistoryCommitFrame(input); return true; } catch { return false; }
}

export interface HistoryPayload {
  commits: HistoryCommitFrame[];
  activeHash: string;
  activeContent: string | null;
}

export const validHistoryPayload = (input: unknown): HistoryPayload => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["commits"] === undefined) throw new Error('`_x["commits"]` required but not present');
    if(_x["commits"] instanceof Array){
    if((_x["commits"] as any)?.length){
      (_x["commits"] as any).forEach((y: unknown) => {
         
  if (y === undefined) throw new Error('`y` required but not present');
  validHistoryCommitFrame(y as any);
      });
    }else{
      _x["commits"] = _x["commits"] === null ? null : [];
    }
  }else {
    throw new Error ('`_x["commits"]` must be an Array');
  }
  if (_x["activeHash"] === undefined) throw new Error('`_x["activeHash"]` required but not present');
  if (typeof _x["activeHash"] != 'string') throw new Error('`_x["activeHash"]` must be a string');
  if (_x["activeContent"] === undefined) throw new Error('`_x["activeContent"]` required but not present');
  if (typeof _x["activeContent"] != 'string' && _x["activeContent"] != null) throw new Error('`_x["activeContent"]` must be a string | null');
  const x = input as HistoryPayload;
  return x;
}
export const isValidHistoryPayload = (input: unknown): boolean => {
  try { validHistoryPayload(input); return true; } catch { return false; }
}

export type EnvVar = "internalPush" | "runnerKeysFile" | "runnerSk" | "runnerPk" | "runnerCapsTimeoutMs" | "secretsKeyFile" | "sshHostKeysDir" | "testDb" | "banditPoolSize" | "nodeCount" | "drainMs" | "gitSshEndpoint"

export const validEnvVar = (x: unknown): EnvVar => {
  const v = x as [string, unknown] | string;
  if(((v != 'internalPush')) && ((v != 'runnerKeysFile')) && ((v != 'runnerSk')) && ((v != 'runnerPk')) && ((v != 'runnerCapsTimeoutMs')) && ((v != 'secretsKeyFile')) && ((v != 'sshHostKeysDir')) && ((v != 'testDb')) && ((v != 'banditPoolSize')) && ((v != 'nodeCount')) && ((v != 'drainMs')) && ((v != 'gitSshEndpoint'))) throw new Error('Invalid EnvVar `' + JSON.stringify(x) + '`');
  return x as EnvVar;
}

export type SecretKind = "sshKey" | "envVar" | "file"

export const validSecretKind = (x: unknown): SecretKind => {
  const v = x as [string, unknown] | string;
  if(((v != 'sshKey')) && ((v != 'envVar')) && ((v != 'file'))) throw new Error('Invalid SecretKind `' + JSON.stringify(x) + '`');
  return x as SecretKind;
}

export type SecretScope = "group" | "repo"

export const validSecretScope = (x: unknown): SecretScope => {
  const v = x as [string, unknown] | string;
  if(((v != 'group')) && ((v != 'repo'))) throw new Error('Invalid SecretScope `' + JSON.stringify(x) + '`');
  return x as SecretScope;
}

export interface Secret {
  scope: SecretScope;
  groupPath: GroupPath;
  repoSlug: string | null;
  name: string;
  kind: SecretKind;
  envelope: string;
  host: string | null;
  loadAsEnv: boolean;
  createdBy: Key<User>;
}

export const validSecret = (input: unknown): Secret => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["scope"] === undefined) throw new Error('`_x["scope"]` required but not present');
  validSecretScope(_x["scope"] as any);
  if (_x["groupPath"] === undefined) throw new Error('`_x["groupPath"]` required but not present');
  
  if (_x["repoSlug"] === undefined) throw new Error('`_x["repoSlug"]` required but not present');
  if (typeof _x["repoSlug"] != 'string' && _x["repoSlug"] != null) throw new Error('`_x["repoSlug"]` must be a string | null');
  if (_x["name"] === undefined) throw new Error('`_x["name"]` required but not present');
  if (typeof _x["name"] != 'string') throw new Error('`_x["name"]` must be a string');
  if (_x["kind"] === undefined) throw new Error('`_x["kind"]` required but not present');
  validSecretKind(_x["kind"] as any);
  if (_x["envelope"] === undefined) throw new Error('`_x["envelope"]` required but not present');
  if (typeof _x["envelope"] != 'string') throw new Error('`_x["envelope"]` must be a string');
  if (_x["host"] === undefined) throw new Error('`_x["host"]` required but not present');
  if (typeof _x["host"] != 'string' && _x["host"] != null) throw new Error('`_x["host"]` must be a string | null');
  // handle html checkbox bs
  if(_x["loadAsEnv"] === undefined){
    _x["loadAsEnv"] = false;
  }else if((_x["loadAsEnv"] as unknown) === 'on'){
    _x["loadAsEnv"] = true;
  }
  if (_x["loadAsEnv"] === undefined) throw new Error('`_x["loadAsEnv"]` required but not present');
  if (typeof _x["loadAsEnv"] != 'boolean') throw new Error('`_x["loadAsEnv"]` must be a boolean');
  if (_x["createdBy"] === undefined) throw new Error('`_x["createdBy"]` required but not present');
  
  const x = input as Secret;
  return x;
}
export const isValidSecret = (input: unknown): boolean => {
  try { validSecret(input); return true; } catch { return false; }
}

export interface SealedSecret {
  name: string;
  kind: SecretKind;
  envelope: string;
  host: string | null;
  loadAsEnv: boolean;
}

export const validSealedSecret = (input: unknown): SealedSecret => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["name"] === undefined) throw new Error('`_x["name"]` required but not present');
  if (typeof _x["name"] != 'string') throw new Error('`_x["name"]` must be a string');
  if (_x["kind"] === undefined) throw new Error('`_x["kind"]` required but not present');
  validSecretKind(_x["kind"] as any);
  if (_x["envelope"] === undefined) throw new Error('`_x["envelope"]` required but not present');
  if (typeof _x["envelope"] != 'string') throw new Error('`_x["envelope"]` must be a string');
  if (_x["host"] === undefined) throw new Error('`_x["host"]` required but not present');
  if (typeof _x["host"] != 'string' && _x["host"] != null) throw new Error('`_x["host"]` must be a string | null');
  // handle html checkbox bs
  if(_x["loadAsEnv"] === undefined){
    _x["loadAsEnv"] = false;
  }else if((_x["loadAsEnv"] as unknown) === 'on'){
    _x["loadAsEnv"] = true;
  }
  if (_x["loadAsEnv"] === undefined) throw new Error('`_x["loadAsEnv"]` required but not present');
  if (typeof _x["loadAsEnv"] != 'boolean') throw new Error('`_x["loadAsEnv"]` must be a boolean');
  const x = input as SealedSecret;
  return x;
}
export const isValidSealedSecret = (input: unknown): boolean => {
  try { validSealedSecret(input); return true; } catch { return false; }
}

export const illuminateAccessLevel = (__x: AccessLevel): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "none": {
  return "None";
  }
  case "read": {
  return "Read";
  }
  case "write": {
  return "Write";
  }
  case "admin": {
  return "Admin";
  }
  }
}

export const illuminateVisibility = (__x: Visibility): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "public": {
  return "Public";
  }
  case "internal": {
  return "Internal";
  }
  case "private": {
  return "Private";
  }
  }
}

export const illuminateKeyUsage = (__x: KeyUsage): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "authentication": {
  return "Authentication";
  }
  case "signing": {
  return "Signing";
  }
  case "authAndSigning": {
  return "Authentication & Signing";
  }
  }
}

export const illuminateSquashSetting = (__x: SquashSetting): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "defaultSquash": {
  return "Default";
  }
  case "doNotAllow": {
  return "Do not allow";
  }
  case "allowSquash": {
  return "Allow";
  }
  case "encourage": {
  return "Encourage";
  }
  case "requireSquash": {
  return "Require";
  }
  }
}

export const illuminatePermissionLevel = (__x: PermissionLevel): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "noOne": {
  return "No one";
  }
  case "developers": {
  return "Developers";
  }
  case "maintainers": {
  return "Maintainers";
  }
  case "developersAndMaintainers": {
  return "Developers + Maintainers";
  }
  }
}

export const illuminateDevSessionPhase = (__x: DevSessionPhase): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "initializing": {
  return "Initializing";
  }
  case "ready": {
  return "Ready";
  }
  case "rebuilding": {
  return "Rebuilding";
  }
  case "draining": {
  return "Draining";
  }
  case "terminated": {
  return "Terminated";
  }
  }
}

export const illuminateDevSessionEvent = (__x: DevSessionEvent): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "sessionReady": {
  return "Session Ready";
  }
  case "flakeChanged": {
  return "Flake Changed";
  }
  case "rebuildDone": {
  return "Rebuild Done";
  }
  case "rebuildFailed": {
  return "Rebuild Failed";
  }
  case "drain": {
  return "Drain";
  }
  case "reconnect": {
  return "Reconnect";
  }
  case "drainTimeout": {
  return "Drain Timeout";
  }
  case "terminate": {
  return "Terminate";
  }
  }
}

export const illuminateAdminEventKind = (__x: AdminEventKind): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "revokeHost": {
  return "Revoke Host";
  }
  case "rotateGroupToken": {
  return "Rotate Group Token";
  }
  case "pinDispatch": {
  return "Pin Dispatch";
  }
  case "changePolicy": {
  return "Change Policy";
  }
  case "revokeSession": {
  return "Revoke Session";
  }
  case "forceTerminate": {
  return "Force Terminate";
  }
  }
}

export const illuminateUser = (x: User): string => unwrapDisplayName(x.displayName)

export const illuminateOidcIdentity = (x: OidcIdentity): string => unwrapOidcSubject(x.subject)

export const illuminateGroup = (x: Group): string => unwrapGroupName(x.name)

export const concealUser = (x: User) => unwrapPasswordHash(x.passwordHash)

export const illuminateSshKey = (x: SshKey): string => unwrapKeyName(x.name)

export const illuminateAdminEvent = (x: AdminEvent): string => String(unwrapBigNatural(unwrapStartedAt(x.occurredAt)))

export const illuminateEnvVar = (__x: EnvVar): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "internalPush": {
  return "OPERATION_INTERNAL_PUSH";
  }
  case "runnerKeysFile": {
  return "OPERATION_RUNNER_KEYS_FILE";
  }
  case "runnerSk": {
  return "OPERATION_RUNNER_SK";
  }
  case "runnerPk": {
  return "OPERATION_RUNNER_PK";
  }
  case "runnerCapsTimeoutMs": {
  return "OPERATION_RUNNER_CAPS_TIMEOUT_MS";
  }
  case "secretsKeyFile": {
  return "OPERATION_SECRETS_KEY_FILE";
  }
  case "sshHostKeysDir": {
  return "OPERATION_SSH_HOST_KEYS_DIR";
  }
  case "testDb": {
  return "OPERATION_TEST_DB";
  }
  case "banditPoolSize": {
  return "OPERATION_BANDIT_POOL_SIZE";
  }
  case "nodeCount": {
  return "OPERATION_NODE_COUNT";
  }
  case "drainMs": {
  return "OPERATION_DRAIN_MS";
  }
  case "gitSshEndpoint": {
  return "OPERATION_GIT_SSH_ENDPOINT";
  }
  }
}

export const illuminateSecretKind = (__x: SecretKind): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "sshKey": {
  return "SSH key";
  }
  case "envVar": {
  return "Environment variable";
  }
  case "file": {
  return "File";
  }
  }
}

export const illuminateSecretScope = (__x: SecretScope): string => {
  const tag = typeof __x === 'string' ? __x : __x[0];
  switch (tag) {
  case "group": {
  return "Group";
  }
  case "repo": {
  return "Repo";
  }
  }
}

export const illuminateSecret = (x: Secret): string => x.name

export const validBigNatural = (x: number): BigNatural => {
  if (typeof x !== 'number') throw new Error('Expected number but got ' + typeof x);
  if ((x) < (0)) throw new Error(`BigNatural must be non-negative`);
  return wrapBigNatural(x);
}
export const isValidBigNatural = (x: number): boolean => {
  try { validBigNatural(x); return true; } catch { return false; }
}

export const validProbability = (x: number): Probability => {
  if (typeof x !== 'number') throw new Error('Expected number but got ' + typeof x);
  if ((x) < (0.0)) throw new Error(`Probability must be >= 0.0`);
  if ((x) > (1.0)) throw new Error(`Probability must be <= 1.0`);
  return wrapProbability(x);
}
export const isValidProbability = (x: number): boolean => {
  try { validProbability(x); return true; } catch { return false; }
}

export const validLoadAverage = (x: number): LoadAverage => {
  if (typeof x !== 'number') throw new Error('Expected number but got ' + typeof x);
  if ((x) < (0.0)) throw new Error(`Load average must be non-negative`);
  return wrapLoadAverage(x);
}
export const isValidLoadAverage = (x: number): boolean => {
  try { validLoadAverage(x); return true; } catch { return false; }
}

export const validKeyBits = (x: Positive): KeyBits => {
  validPositive(x);
  if ((unwrapNatural(unwrapPositive(x))) < (256)) throw new Error(`Key must be >= 256 bits`);
  return wrapKeyBits(x);
}
export const isValidKeyBits = (x: Positive): boolean => {
  try { validKeyBits(x); return true; } catch { return false; }
}

export const validExitCode = (x: number): ExitCode => {
  if (typeof x !== 'number') throw new Error('Expected number but got ' + typeof x);
  if ((x) < (-1)) throw new Error(`Exit code must be >= -1`);
  if ((x) > (255)) throw new Error(`Exit code must be <= 255`);
  return wrapExitCode(x);
}
export const isValidExitCode = (x: number): boolean => {
  try { validExitCode(x); return true; } catch { return false; }
}

export const validRamBytes = (x: BigNatural): RamBytes => {
  validBigNatural(x);
  if ((unwrapBigNatural(x)) > (9223372036854775807)) throw new Error(`RAM byte count must fit a signed 64-bit integer`);
  return wrapRamBytes(x);
}
export const isValidRamBytes = (x: BigNatural): boolean => {
  try { validRamBytes(x); return true; } catch { return false; }
}

export const validProtocolVersion = (x: Positive): ProtocolVersion => {
  validPositive(x);
  if ((unwrapNatural(unwrapPositive(x))) > (1000)) throw new Error(`Protocol version above 1000 is implausible`);
  return wrapProtocolVersion(x);
}
export const isValidProtocolVersion = (x: Positive): boolean => {
  try { validProtocolVersion(x); return true; } catch { return false; }
}

export const allAccessLevels: Set<AccessLevel> =
  new Set(['none', 'read', 'write', 'admin'])


export const orderedAccessLevels: AccessLevel[] =
  ['none', 'read', 'write', 'admin']


export const visibilityBadgeVariant = (v: Visibility): string => {
  return (() => {switch (typeof v === 'string' ? v : (v as [string, unknown])[0]) {
      case "public": {
        return "success";
      }
      case "internal": {
        return "info";
      }
      case "private": {
        return "warning";
      }
    default: throw new Error('unreachable');
    }})()
}

export const allVisibilities: Set<Visibility> =
  new Set(['public', 'internal', 'private'])


export const orderedVisibilities: Visibility[] =
  ['public', 'internal', 'private']


export const authenticatingKeyUsages: Set<KeyUsage> =
  new Set(['authentication', 'authAndSigning'])


export const allSquashSettings: Set<SquashSetting> =
  new Set(['defaultSquash', 'doNotAllow', 'allowSquash', 'encourage', 'requireSquash'])


export const allPermissionLevels: Set<PermissionLevel> =
  new Set(['noOne', 'developers', 'maintainers', 'developersAndMaintainers'])


export const allDevSessionPhases: Set<DevSessionPhase> =
  new Set(['initializing', 'ready', 'rebuilding', 'draining', 'terminated'])


export const devSessionPhaseFilterExclusions: Set<DevSessionPhase> =
  new Set(['terminated'])


export const devSessionPhaseBadgeVariant = (p: DevSessionPhase): string => {
  return (() => {switch (typeof p === 'string' ? p : (p as [string, unknown])[0]) {
      case "initializing": {
        return "info";
      }
      case "ready": {
        return "success";
      }
      case "rebuilding": {
        return "warning";
      }
      case "draining": {
        return "warning";
      }
      case "terminated": {
        return "default";
      }
    default: throw new Error('unreachable');
    }})()
}

export const adminEventKindBadgeVariant = (k: AdminEventKind): string => {
  return (() => {switch (typeof k === 'string' ? k : (k as [string, unknown])[0]) {
      case "revokeHost": {
        return "danger";
      }
      case "rotateGroupToken": {
        return "warning";
      }
      case "pinDispatch": {
        return "info";
      }
      case "changePolicy": {
        return "info";
      }
      case "revokeSession": {
        return "warning";
      }
      case "forceTerminate": {
        return "danger";
      }
    default: throw new Error('unreachable');
    }})()
}

export const allAdminEventKinds: Set<AdminEventKind> =
  new Set(['revokeHost', 'rotateGroupToken', 'pinDispatch', 'changePolicy', 'revokeSession', 'forceTerminate'])


export const defaultGroupMembershipMachineContext: GroupMembershipMachineContext =
  {
    'placeholder': 0,
    'zero': 0,
  }


export const createUser: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/users",
    'query': null,
    'fragment': null,
    'io': 'User. User',
    'meta': new Set(["POST"]),
    'accept': null,
  }


export const listUsers: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/users",
    'query': null,
    'fragment': null,
    'io': 'Unit. [User]',
    'meta': new Set(["GET"]),
    'accept': null,
  }


export const createOidcIdentity: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/oidc-identities",
    'query': null,
    'fragment': null,
    'io': 'OidcIdentity. OidcIdentity',
    'meta': new Set(["POST"]),
    'accept': null,
  }


export const listOidcIdentities: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/oidc-identities",
    'query': null,
    'fragment': null,
    'io': 'Unit. [OidcIdentity]',
    'meta': new Set(["GET"]),
    'accept': null,
  }


export const createGroup: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/groups",
    'query': null,
    'fragment': null,
    'io': 'Group. Group',
    'meta': new Set(["POST"]),
    'accept': null,
  }


export const listGroups: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/groups",
    'query': null,
    'fragment': null,
    'io': 'Unit. [Group]',
    'meta': new Set(["GET"]),
    'accept': null,
  }


export const createGroupMembership: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/group-memberships",
    'query': null,
    'fragment': null,
    'io': 'GroupMembership. GroupMembership',
    'meta': new Set(["POST"]),
    'accept': null,
  }


export const listGroupMemberships: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/group-memberships",
    'query': null,
    'fragment': null,
    'io': 'Unit. [GroupMembership]',
    'meta': new Set(["GET"]),
    'accept': null,
  }


export const createSshKey: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/ssh-keys",
    'query': null,
    'fragment': null,
    'io': 'SshKey. SshKey',
    'meta': new Set(["POST"]),
    'accept': null,
  }


export const listSshKeys: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/ssh-keys",
    'query': null,
    'fragment': null,
    'io': 'Unit. [SshKey]',
    'meta': new Set(["GET"]),
    'accept': null,
  }


export const createAdminEvent: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/admin-events",
    'query': null,
    'fragment': null,
    'io': 'AdminEvent. AdminEvent',
    'meta': new Set(["POST"]),
    'accept': null,
  }


export const listAdminEvents: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/admin-events",
    'query': null,
    'fragment': null,
    'io': 'Unit. [AdminEvent]',
    'meta': new Set(["GET"]),
    'accept': null,
  }


export const devSessionEventWire = (e: DevSessionEvent): string => {
  return (() => {switch (typeof e === 'string' ? e : (e as [string, unknown])[0]) {
      case "sessionReady": {
        return "session_ready";
      }
      case "flakeChanged": {
        return "flake_changed";
      }
      case "rebuildDone": {
        return "rebuild_done";
      }
      case "rebuildFailed": {
        return "rebuild_failed";
      }
      case "drain": {
        return "drain";
      }
      case "reconnect": {
        return "reconnect";
      }
      case "drainTimeout": {
        return "drain_timeout";
      }
      case "terminate": {
        return "terminate";
      }
    default: throw new Error('unreachable');
    }})()
}

export const devSessionPhaseWire = (p: DevSessionPhase): string => {
  return (() => {switch (typeof p === 'string' ? p : (p as [string, unknown])[0]) {
      case "initializing": {
        return "initializing";
      }
      case "ready": {
        return "ready";
      }
      case "rebuilding": {
        return "rebuilding";
      }
      case "draining": {
        return "draining";
      }
      case "terminated": {
        return "terminated";
      }
    default: throw new Error('unreachable');
    }})()
}

export const allEnvVars: Set<EnvVar> =
  new Set(['internalPush', 'runnerKeysFile', 'runnerSk', 'runnerPk', 'runnerCapsTimeoutMs', 'secretsKeyFile', 'sshHostKeysDir', 'testDb', 'banditPoolSize', 'nodeCount', 'drainMs', 'gitSshEndpoint'])


export const secretKindWireForm = (kind: SecretKind): string => {
  return (() => {switch (typeof kind === 'string' ? kind : (kind as [string, unknown])[0]) {
      case "sshKey": {
        return "ssh_key";
      }
      case "envVar": {
        return "env_var";
      }
      case "file": {
        return "file";
      }
    default: throw new Error('unreachable');
    }})()
}

export const allSecretKinds: Set<SecretKind> =
  new Set(['sshKey', 'envVar', 'file'])


export const allSecretScopes: Set<SecretScope> =
  new Set(['group', 'repo'])


export const createSecret: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/secrets",
    'query': null,
    'fragment': null,
    'io': 'Secret. Secret',
    'meta': new Set(["POST"]),
    'accept': null,
  }


export const listSecrets: URI =
  {
    'scheme': "http",
    'authority': {
      'user': null,
      'name': "localhost",
      'port': null,
    },
    'path': "/secrets",
    'query': null,
    'fragment': null,
    'io': 'Unit. [Secret]',
    'meta': new Set(["GET"]),
    'accept': null,
  }


// Generated FSM: groupMembershipStatus

export type GroupMembershipStatusTransitionResult = {
  target: GroupMembershipStatus;
  context: GroupMembershipMachineContext;
};

export function groupMembershipStatusTransition(
  state: GroupMembershipStatus,
  event: GroupMembershipEvent,
  context: GroupMembershipMachineContext
): GroupMembershipStatusTransitionResult {
  switch (state) {
    case "invited": {
      switch (event) {
        case "acceptInvitation":
          return { target: "accepted", context };
        case "declineInvitation":
          return { target: "closed", context };
        case "revokeInvitation":
          return { target: "closed", context };
        default:
          return { target: state, context };
      }
    }
    case "accepted": {
      switch (event) {
        case "acceptInvitation":
          return { target: "accepted", context };
        case "revokeInvitation":
          return { target: "closed", context };
        case "declineInvitation":
          return { target: "accepted", context };
        default:
          return { target: state, context };
      }
    }
    case "closed": {
      switch (event) {
        case "acceptInvitation":
          return { target: "closed", context };
        case "declineInvitation":
          return { target: "closed", context };
        case "revokeInvitation":
          return { target: "closed", context };
        default:
          return { target: state, context };
      }
    }
    default:
      return { target: state, context };
  }
}

export function validTransitionGroupMembershipStatus(from: GroupMembershipStatus, event: GroupMembershipEvent): boolean {
  switch (from) {
    case "invited": {
      switch (event) {
        case "acceptInvitation":
          return true;
        case "declineInvitation":
          return true;
        case "revokeInvitation":
          return true;
        default:
          return false;
      }
    }
    case "accepted": {
      switch (event) {
        case "acceptInvitation":
          return true;
        case "revokeInvitation":
          return true;
        case "declineInvitation":
          return true;
        default:
          return false;
      }
    }
    case "closed": {
      switch (event) {
        case "acceptInvitation":
          return true;
        case "declineInvitation":
          return true;
        case "revokeInvitation":
          return true;
        default:
          return false;
      }
    }
    default:
      return false;
  }
}

export function terminalGroupMembershipStatus(state: GroupMembershipStatus): boolean {
  switch (state) {
    case "closed":
      return true;
    default:
      return false;
  }
}

//# sourceMappingURL=runtime.ts.map
